<template>
    <div class="py-3 px-5" style="background-color: #f5f5f5;height: 98.3vh;">
        <div class="col-12 text-start mx-auto">
            <img src="../../../public/img/logo-white.png" style="width: 100px;cursor: pointer;" alt="" @click="router.push({name:'home'})">
        </div>
        <div class="col-md-5 col-sm-9 col-11 mx-auto mt-5 pt-5">
            <div class="px-sm-5 my-5">
                <div class="px-sm-5 px-4">
                    <h4 class="text-center">Sign in to the online signal panel</h4>
                    <!-- <a class="navbar-brand" href="../"><img src="../../public/img/logo-white.png" style="height: 100px;" alt=""></a> -->
                    <div class="row my-3 text-end">
                        <!-- <lable class="w-100 mt-3">شماره تلفن :</lable> -->
                        <input type="text" name="" class="w-100 py-3" v-model="phone" placeholder="phone number">
                        <!-- <lable class="w-100 mt-3">پسوورد :</lable> -->
                        <input type="password" name="" class="w-100 mt-3 py-3" v-model="password" placeholder="password">
                        <button class="btn-blue mt-4 px-5 fs-6" @click="login()">Sign in</button>
                        <!-- <a href="../sign-up" class="mt-4 text-center fs-6">ثبت نام</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({

    setup() {
        const phone = ref()
        const password = ref()
        const router = useRouter()
        
        onMounted(() => {
            if (localStorage.getItem('credits')) {
              router.push({'name':'online-signals',params:{id: localStorage.getItem('id')}})
            }
        })

        function login(){
            if (!phone.value || !password.value) {
            alert("please enter phone number or password.");
            return;
            }
            else {
                axios.put('https://api.xaifin.com/user/login',{'username':phone.value,'password':password.value}).then((res)=>{
                    if (res.status==200) {
                        localStorage.setItem('users',phone.value)
                        localStorage.setItem('credits',res.data.user.credits)
                        router.push({'name':'online-signals',params:{id:res.data.user._id}})
                    }
                }).catch((error)=>{                    
                    Swal.fire({
                          text: error.response.data.mess,
                          icon: "error"
                        });
                })
            }
        }
        return{
            phone,
            password,
            router,
            login
        }
    }

})
</script>
<style scoped lang="scss">
.card-custom {
    box-shadow: 0px 0px 5px 0px #adadad;
    border: none;
    border-radius: 8px;
    background-color: white;
}
</style>